import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import * as Styled from "./misc/styled";

const ParagraphField = (props) => {
  const {
    paragraph: { id, value, order },
    onEdit,
    onDelete,
  } = props;

  const handleOnEdit = () => {
    onEdit();
  };

  const handleOnDelete = () => {
    onDelete(id, "paragraphs");
  };

  return (
    <Styled.ParagraphContainer>
      <p title={value}>{`(${order}) ${value}`}</p>
      <span onClick={handleOnEdit}>
        <FontAwesomeIcon icon={faEdit} />
      </span>
      <span onClick={handleOnDelete}>
        <FontAwesomeIcon icon={faTimes} />
      </span>
    </Styled.ParagraphContainer>
  );
};

ParagraphField.propTypes = {
  paragraph: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
    order: PropTypes.number,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ParagraphField;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/ParagraphField.js